import { ButtonMantine, Modal, ModalProps, Stack, Text, TextInput, notifications } from 'ui';
import { isEmail, useForm } from 'ui/Form';

import { useResetPassword } from '../../../api';

const ResetPasswordContent = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { mutate: resetPassword, isPending: isLoading } = useResetPassword();

  const form = useForm({
    initialValues: {
      email: '',
    },
    validate: {
      email: isEmail('Email is invalid'),
    },
  });
  const handleResetPassword = () => {
    const { email } = form.values;
    if (form.validate().hasErrors) return;
    resetPassword(
      { user: { email } },
      {
        onSuccess: () => {
          onSuccess?.();
          notifications.show({
            message: `Great! We've sent a link to reset your password to ${email}`,
            variant: 'success',
          });
        },
        onError: () => {
          notifications.show({
            message: `There's no account associated with ${email || 'your email'}`,
            variant: 'error',
          });
        },
      }
    );
  };
  return (
    <Stack gap={'lg'}>
      <Text>We’ll send you an email with a link to reset your password.</Text>
      <TextInput placeholder="Email Address" {...form.getInputProps('email')} />
      <ButtonMantine onClick={handleResetPassword} loading={isLoading} fullWidth variant="gradient">
        Send Password Reset Link
      </ButtonMantine>
    </Stack>
  );
};

export const ResetPasswordModal = ({
  opened,
  onClose,
  onSuccess,
  modalProps,
}: {
  opened: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  modalProps?: Partial<ModalProps>;
}) => {
  return (
    <Modal onClose={onClose} opened={opened} title="Reset Password" {...modalProps}>
      <ResetPasswordContent onSuccess={onSuccess} />
    </Modal>
  );
};
